import styled from 'styled-components';

export const BodyElem = styled.div`
  ${({ theme }) => `
    display: flex;
    padding: ${theme.layout.spacing.mega};
  `};
`;
